'use client';

import { useEffect, useRef } from 'react';
import { useToastStore } from '../model/toast-store';
import { useRealtimeAgentStore } from '@/shared/store/realtime-agent';

/**
 * STT 토스트 훅
 * 음성 인식 결과를 토스트로 표시
 *
 * 표시 조건: 음성 모드에서 STT 결과가 도착했을 때
 */
export const useSttToast = (currentMode: 'voice' | 'chat') => {
  const showToast = useToastStore((s) => s.showToast);
  const lastSttIdRef = useRef<string | null>(null);

  useEffect(() => {
    // 음성 모드가 아니면 구독하지 않음
    if (currentMode !== 'voice') return;

    const unsubscribe = useRealtimeAgentStore.subscribe(
      (state) => state.currentSttResult,
      (sttResult) => {
        if (!sttResult) return;

        // 중복 방지: 같은 STT 결과가 다시 오면 무시
        const sttId = `${sttResult.text}-${Date.now()}`;
        if (lastSttIdRef.current === sttId) return;
        lastSttIdRef.current = sttId;

        // STT 토스트 표시
        showToast({
          type: 'stt',
          message: sttResult.text,
          position: 'bottom',
          duration: 3000,
        });
      }
    );

    return () => unsubscribe();
  }, [currentMode, showToast]);
};
